export default function () {
  return {
    success: null,
    error: null,
    customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
    datePickerConfig: {
      nextMonthCaption: 'Próximo mês',
      prevMonthCaption: 'Mês anterior',
      setTimeCaption: 'Hora',
      weekdays: [
        'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
      ],
      months: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
    },
    post: {
      title: '',
      showFrom: null,
      showUntil: null,
      body: ''
    },
    errors: {
      title: null,
      showFrom: null,
      showUntil: null,
      body: null
    }
  }
}
